import View from '~/app/View'

// Product grid images
import ProductImageFormGrid from '~/components/product/product-image-form-grid'

// Product thumbnails slider
import ProductThumbnailsSlider from '~/components/product/product-thumbnails-slider'
import ProductThumbnailsScrollEvents from '~/components/product/product-thumbnails-scroll-events'

// Product form
import ProductForm from '~/components/product/product-form'
import ProductFormFixed from '~/components/product/product-form-fixed'
import ProductFormState from '~/components/product/product-form-state'

// Product description
import ProductDescription from '~/components/product/product-description'

// Size guide
import SizeGuide from '~/components/product/size-guide'

// Styled with section
import ProductStyledWith from '~/components/product/product-styled-with'

import ProductCrossSells from '~/components/product/product-cross-sells'
import ProductHalfVideoGridSlider from '~/components/product/product-half-video-grid-slider'
import ProductHalfVideoSlider from '~/components/product/product-half-video-slider'
// Product recommendations
import ProductRecommendations from '~/components/product/product-recommendations'

// Back in stock popup
import BackInStockPopup from '~/components/product/back-in-stock-popup'

import '@/templates/product.scss'

const productViewComponents = {
  ProductImageFormGrid,
  ProductForm,
  ProductFormFixed,
  ProductFormState,
  ProductDescription,
  ProductStyledWith,
  ProductCrossSells,
  ProductRecommendations,
  ProductHalfVideoGridSlider,
  ProductHalfVideoSlider,
  ProductThumbnailsSlider,
}

const productViewColorChangeComponents = {
  ProductImageFormGrid,
  ProductFormState,
  ProductDescription,
  ProductStyledWith,
  ProductCrossSells,
  ProductRecommendations,
  ProductHalfVideoGridSlider,
  ProductHalfVideoSlider,
  ProductThumbnailsSlider,
}

const productView = new View()
productView.init(productViewComponents)

const popupViews = new View()
popupViews.init({
  SizeGuide,
  BackInStockPopup,
})

ProductThumbnailsScrollEvents().init()

document.addEventListener('colorchange', () => {
  window.basis.EventBus.emit('swiper-destroy')
  const productViewColorChange = new View()
  productViewColorChange.init(productViewColorChangeComponents)
  productViewColorChange.mountComponents()
})
